'use strict';

exports.__esModule = true;
exports.default = functor;

var _ramda = require('ramda');

function functor(v) {
  return (0, _ramda.is)(Function, v) ? v : function () {
    return v;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3tooltip/lib/utils/functor.js
// module id = 180
// module chunks = 0